import React from 'react';
import OnPlanEndErrorHandler from './OnPlanEndErrorHandler';
import { ErrorCatcher } from './components/ErrorCatcher';


const ErrorDispatcher = ({ error, ...props }) => {
  if (! error) {
    return null;
  } 
  const errorCode = error?.response?.data?.error_code;
  // alert(`ErrorDispatcher: ${errorCode}`);

  if (errorCode === 4032 || errorCode === 4033 || errorCode === 4100) {
    // console.log('OnPlanEndErrorHandler triggered');
    return <OnPlanEndErrorHandler 
            error={error} 
            errorCode={errorCode} 
            resetError={props.resetError}
            {...props} 
            
          />;
  }

  return <ErrorCatcher error={error} {...props} />;
};

export default ErrorDispatcher;
